export const key = "accio-jobs-event-2023";
